import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import qs from 'qs';
import config from 'utils/config';

/* eslint-disable  @typescript-eslint/no-explicit-any */
type TBody = any;

export class BaseService {
  private _axios: AxiosInstance;

  constructor(authRequired = true) {
    const headers: Record<string, string> = {};
    if (authRequired) {
      const token = localStorage.getItem('Authorization') || sessionStorage.getItem('Authorization');
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    }

    this._axios = axios.create({
      baseURL: config.REACT_APP_API_URL,
      timeout: 5000,
      headers,
    });
  }

  private executeSendRequest(method: 'post' | 'patch' | 'put') {
    return <T>(url: string, body?: TBody, headers?: any) => {
      return this._axios[method](
        url,
        body,
        {
          headers: { ...headers },
          mode: 'cors',
        } as AxiosRequestConfig<T>
      ).then((item: any) => item.data as T);
    };
  }

  private executeGetRequest(method: 'get' | 'delete') {
    return <T>(url: string, query?: Record<string, unknown> | null, headers?: any) => {
      if (query) {
        url += `?${qs.stringify(query, { encode: true })}`;
      }
      return this._axios[method]<Record<string, unknown>, { data: T}>(
        url,
        {
          headers: { ...headers },
          mode: 'cors',
        } as AxiosRequestConfig<T>
      ).then((item: any) => item.data);
    };
  }

  public get post() {
    return this.executeSendRequest('post');
  }

  public get get() {
    return this.executeGetRequest('get');
  }

  public get patch() {
    return this.executeSendRequest('patch');
  }

  public get put() {
    return this.executeSendRequest('put');
  }

  public get delete() {
    return this.executeGetRequest('delete');
  }
}

export const baseService = new BaseService(true);
export const publicService = new BaseService(false);
